module.exports = __webpack_public_path__ + "img/cloud_download.0073eabe.svg";